<template>
  <section id="single-schedule">
    <dayone />
    <daytwo />
  </section>
</template>

<script>
import dayone from '@/components/vegas/agenda/dayone.vue';
import daytwo from '@/components/vegas/agenda/daytwo.vue';

export default {
  name: 'Agenda Vegas',
  components: {
    dayone,
    daytwo
  },
};
</script>

<style lang="scss" scoped>
  #single-schedule {
    padding: 20px 0 60px !important;
  }
</style>